import clsx from 'clsx';

interface IRenexisAppLogoSVGProps {
  className?: string;
  /**
   * This style overrides the default style for the slogan
   */
  classNameSlogan?: string;
  /**
   * invert A boolean value to invert the logo color
   */
  isInverted?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This used to render renexis app logo as svg in dom
 */
export function RenexisLogoSVG({
  className,
  classNameSlogan,
  isInverted = true,
}: IRenexisAppLogoSVGProps) {
  const color = isInverted ? 'fill-white' : 'fill-gray-950';

  return (
    <svg
      className={clsx(
        'group transition-all duration-1000 ease-in-out',
        color,
        className
      )}
      id="renexis-logo"
      viewBox="0 0 130 50"
    >
      <g id="logo">
        <g id="renexis">
          <path
            d="M6.12,11.63c.84-1.87,2.29-2.72,3.77-2.72.68,0,1.35.16,1.95.47l-1.38,3.85c-.4-.22-.85-.34-1.31-.37-1.28,0-2.29,1.48-2.39,4.1v10.29H2.24V9.37h3.87v2.25Z"
            id="r"
          />
          <path
            d="M30.55,23.78c-1.91,2.72-4.44,3.93-8.21,3.93-5.69,0-9.35-4.17-9.35-9.43,0-4.88,3.53-9.39,9.29-9.39s9.47,4.04,9.47,9.69v1.01h-14.43c.44,2.66,2.46,4.14,4.99,4.14.83.04,1.65-.09,2.42-.39.77-.3,1.46-.77,2.04-1.36l3.78,1.79ZM27.25,16.07c-.62-2.09-2.52-3.37-4.91-3.37-1.06-.04-2.1.27-2.97.88s-1.52,1.48-1.85,2.49h9.73Z"
            id="e"
          />
          <path
            d="M39.81,11.19c1.72-1.45,3.3-2.29,5.29-2.29,3.33,0,6.13,2.29,6.13,6.13v12.22h-4.48v-8.45c0-3.53-.31-5.79-3.03-5.79-.61,0-1.21.15-1.74.46-.53.3-.97.73-1.29,1.26-.91,1.45-.88,3.06-.88,4.91v7.61h-4.48V9.37h4.48v1.81Z"
            id="n"
          />
          <path
            d="M72.28,23.78c-1.92,2.72-4.44,3.93-8.21,3.93-5.69,0-9.35-4.17-9.35-9.43,0-4.88,3.53-9.39,9.29-9.39s9.49,4.04,9.49,9.69v1.01h-14.43c.44,2.66,2.46,4.14,4.99,4.14.83.05,1.66-.08,2.43-.39.77-.3,1.47-.77,2.05-1.37l3.74,1.79ZM68.98,16.07c-.62-2.09-2.49-3.37-4.91-3.37-1.06-.04-2.1.27-2.97.88-.87.61-1.52,1.48-1.85,2.49h9.73Z"
            id="e"
          />
          <path
            className="duration-5000 fill-green-600 transition-all ease-in-out group-hover:fill-green-500"
            d="M104.88,29.88c-.43,1.06-1.16,1.98-2.11,2.61-.95.64-2.08.97-3.22.96-.76,0-1.51-.15-2.21-.44-.7-.29-1.34-.72-1.87-1.25l-7.32-7.32c-.84-.84-1.94-1.4-3.12-1.58-.22-.03-.44-.05-.67-.06-.76-.03-1.51.1-2.22.37-.71.27-1.35.68-1.9,1.21l-2.49,2.42c-.29.29-.49.66-.56,1.06-.08.4-.04.81.12,1.19.16.38.42.7.76.93.34.23.74.35,1.15.35.54,0,1.06-.21,1.45-.59l.77-.77-.23-.19c-.2-.16-.35-.37-.44-.61-.09-.24-.11-.5-.06-.75.05-.25.16-.48.33-.67.17-.19.39-.33.63-.4l1.87-.59,1.85-.7c.24-.09.49-.11.74-.07.25.04.48.16.67.32.19.17.33.38.41.62.08.24.09.5.04.75l-.24,1.05-.19.85-.31,1.94c-.04.25-.15.49-.31.68-.16.2-.38.34-.62.43-.24.08-.5.1-.75.05-.25-.05-.48-.17-.67-.35l-.38-.36-.94.94c-.97.96-2.28,1.5-3.64,1.5-.79,0-1.57-.19-2.27-.55-.71-.35-1.32-.86-1.8-1.49-.48-.63-.81-1.35-.97-2.13-.16-.77-.14-1.57.06-2.34.25-.9.73-1.73,1.41-2.38l2.49-2.42c1.65-1.59,3.86-2.47,6.15-2.46,2.29.02,4.49.93,6.11,2.54l7.33,7.33c.25.25.54.44.86.58.32.13.67.2,1.01.2.53.01,1.06-.14,1.51-.43.45-.29.79-.72.99-1.22.19-.43.25-.91.19-1.38-.06-.47-.25-.91-.55-1.27-.07-.09-.14-.17-.22-.26l-4.66-4.66c-.66-.65-1.15-1.45-1.41-2.34-.26-.89-.29-1.83-.07-2.73.22-.93.68-1.77,1.35-2.46l4.11-4.25c.35-.35.58-.79.67-1.27.09-.48.03-.98-.17-1.43-.1-.24-.24-.46-.41-.66-.23-.27-.52-.49-.84-.64-.32-.15-.68-.22-1.03-.22-.33,0-.66.07-.96.19-.3.13-.58.31-.81.55l-4.06,4.13c-.49.5-1.08.9-1.73,1.17-.65.27-1.34.41-2.04.41-.7,0-1.39-.14-2.03-.41-.64-.27-1.22-.66-1.71-1.16l-4.11-4.13c-.23-.23-.51-.42-.81-.54-.3-.13-.63-.19-.96-.19-.4,0-.79.08-1.14.26-.35.18-.65.45-.88.77-.11.15-.2.31-.27.48-.2.45-.26.94-.17,1.42.09.48.32.92.67,1.27h.03l4.2,4.63,2.45,2.7c-1.27-.11-2.55.07-3.74.51l-5.21-5.71c-.64-.66-1.11-1.48-1.35-2.37-.25-.89-.26-1.83-.05-2.73.08-.32.18-.62.31-.92.41-1.02,1.13-1.9,2.04-2.51.92-.61,2-.94,3.1-.93.74,0,1.47.15,2.15.43.68.28,1.3.7,1.82,1.23l4.08,4.14c.21.2.45.36.72.47.27.11.55.16.84.16.29,0,.58-.05.84-.16.27-.11.51-.27.72-.47l4.06-4.13c.52-.53,1.14-.95,1.82-1.23.68-.29,1.42-.44,2.16-.44,1.1-.01,2.18.31,3.1.92.92.61,1.63,1.48,2.05,2.49.06.14.11.28.16.43.33.97.39,2.01.16,3-.23,1-.73,1.91-1.44,2.64l-4.12,4.23s-.08.08-.11.13c-.36.44-.55.99-.52,1.56.03.57.26,1.1.66,1.51l4.67,4.65c.82.8,1.37,1.83,1.59,2.96.22,1.12.1,2.29-.35,3.34v.02Z"
            id="X"
          />
          <path
            d="M113.06,4.96c0,.76-.3,1.49-.84,2.02-.54.54-1.26.84-2.02.84-.39-.02-.78-.11-1.13-.27-.36-.17-.68-.4-.94-.69s-.47-.63-.61-1c-.14-.37-.19-.76-.18-1.16.02-.74.33-1.44.87-1.94.54-.51,1.25-.78,1.99-.76.38,0,.76.09,1.11.24.35.15.67.37.93.65.27.28.47.6.61.96.14.36.21.74.2,1.12ZM107.98,9.38h4.48v17.87h-4.48V9.38Z"
            id="i"
          />
          <path
            d="M120.06,19.5c-2.86-1.45-4.31-3.2-4.31-5.45,0-2.79,2.36-5.15,5.79-5.15,1.15,0,2.28.26,3.3.77,1.02.51,1.91,1.26,2.59,2.19l-2.76,2.79c-1-1.01-2.01-1.65-3.12-1.65-.91,0-1.61.37-1.61,1.07s.62.98,1.61,1.48l1.65.84c2.99,1.51,4.56,3.05,4.56,5.72,0,3.2-2.52,5.61-6.43,5.61-1.21.03-2.4-.24-3.49-.77-1.08-.53-2.03-1.32-2.74-2.29l2.75-3.03c1.05,1.21,2.56,2.09,3.74,2.09s1.98-.62,1.98-1.45-.74-1.35-1.98-1.99l-1.53-.8Z"
            id="s"
          />
        </g>
        <g className={classNameSlogan} id="slogan">
          <g id="Recover.">
            <path
              d="M14.28,47.93l-1.23-2.18h-.53v2.18h-1.12v-5.58h2.1c.43,0,.8.08,1.1.23.3.15.53.36.68.62.15.26.23.55.23.87,0,.37-.11.7-.32,1-.21.3-.53.5-.95.61l1.34,2.26h-1.3ZM12.52,44.91h.94c.3,0,.53-.07.68-.22.15-.15.22-.35.22-.61s-.08-.46-.22-.6c-.15-.14-.38-.21-.68-.21h-.94v1.64Z"
              id="r-2"
            />
            <path
              d="M20.61,46.05h-3.24c.03.32.14.57.34.75.2.18.44.27.73.27.42,0,.71-.18.89-.54h1.21c-.13.43-.37.78-.74,1.05-.36.27-.81.41-1.34.41-.43,0-.81-.09-1.15-.28-.34-.19-.6-.46-.79-.8s-.28-.75-.28-1.2.09-.86.28-1.21.45-.61.78-.8.72-.28,1.16-.28.8.09,1.13.27c.33.18.59.44.78.77.18.33.28.72.28,1.15,0,.16-.01.3-.03.43ZM19.49,45.3c0-.29-.11-.52-.31-.69-.2-.17-.45-.26-.74-.26-.28,0-.51.08-.7.25s-.31.4-.35.7h2.1Z"
              id="e-3"
            />
            <path
              d="M21.45,44.51c.19-.34.45-.61.78-.8s.71-.28,1.14-.28c.55,0,1,.14,1.36.41.36.27.6.66.72,1.16h-1.21c-.06-.19-.17-.34-.32-.45-.15-.11-.34-.16-.56-.16-.32,0-.57.12-.76.35-.19.23-.28.56-.28.99s.09.75.28.98c.19.23.44.35.76.35.45,0,.75-.2.89-.61h1.21c-.12.48-.37.86-.73,1.14-.36.28-.82.42-1.36.42-.43,0-.81-.09-1.14-.28s-.59-.46-.78-.8-.28-.75-.28-1.2.09-.86.28-1.2Z"
              id="c"
            />
            <path
              d="M27.09,47.72c-.34-.19-.61-.46-.8-.8s-.29-.75-.29-1.2.1-.85.3-1.2c.2-.35.47-.61.82-.8s.73-.28,1.16-.28.81.09,1.16.28.62.46.82.8c.2.35.3.75.3,1.2s-.1.85-.31,1.2c-.21.35-.48.61-.83.8s-.74.28-1.17.28-.81-.09-1.15-.28ZM28.82,46.88c.18-.1.32-.25.43-.44.11-.2.16-.44.16-.72,0-.42-.11-.75-.33-.97-.22-.23-.49-.34-.81-.34s-.59.11-.8.34c-.22.23-.32.55-.32.97s.1.75.32.97c.21.23.48.34.8.34.2,0,.39-.05.57-.15Z"
              id="o"
            />
            <path
              d="M33.23,46.9l1.12-3.4h1.19l-1.64,4.43h-1.36l-1.63-4.43h1.2l1.12,3.4Z"
              id="v"
            />
            <path
              d="M40.26,46.05h-3.24c.03.32.14.57.34.75.2.18.44.27.73.27.42,0,.71-.18.89-.54h1.21c-.13.43-.37.78-.74,1.05-.36.27-.81.41-1.34.41-.43,0-.81-.09-1.15-.28-.34-.19-.6-.46-.79-.8s-.28-.75-.28-1.2.09-.86.28-1.21.45-.61.78-.8.72-.28,1.16-.28.8.09,1.13.27c.33.18.59.44.78.77.18.33.28.72.28,1.15,0,.16-.01.3-.03.43ZM39.13,45.3c0-.29-.11-.52-.31-.69-.2-.17-.45-.26-.74-.26-.28,0-.51.08-.7.25s-.31.4-.35.7h2.1Z"
              id="e-4"
            />
            <path
              d="M42.79,43.63c.23-.13.5-.2.8-.2v1.18h-.3c-.35,0-.62.08-.8.25-.18.17-.27.45-.27.86v2.21h-1.12v-4.43h1.12v.69c.14-.23.33-.42.56-.55Z"
              id="r-3"
            />
            <path
              d="M44.34,47.8c-.13-.12-.2-.28-.2-.47s.07-.34.2-.47c.13-.13.3-.19.5-.19s.36.06.49.19c.13.12.19.28.19.47s-.06.34-.19.47-.29.19-.49.19-.37-.06-.5-.19Z"
              id="_x2E_"
            />
          </g>
          <g id="Renew.">
            <path
              d="M51.77,47.93l-1.23-2.18h-.53v2.18h-1.12v-5.58h2.1c.43,0,.8.08,1.1.23.3.15.53.36.68.62.15.26.23.55.23.87,0,.37-.11.7-.32,1-.21.3-.53.5-.95.61l1.34,2.26h-1.3ZM50.01,44.91h.94c.3,0,.53-.07.68-.22.15-.15.22-.35.22-.61s-.08-.46-.22-.6c-.15-.14-.38-.21-.68-.21h-.94v1.64Z"
              id="r-4"
            />
            <path
              d="M58.11,46.05h-3.24c.03.32.14.57.34.75.2.18.44.27.73.27.42,0,.71-.18.89-.54h1.21c-.13.43-.37.78-.74,1.05-.36.27-.81.41-1.34.41-.43,0-.81-.09-1.15-.28-.34-.19-.6-.46-.79-.8s-.28-.75-.28-1.2.09-.86.28-1.21.45-.61.78-.8.72-.28,1.16-.28.8.09,1.13.27c.33.18.59.44.78.77.18.33.28.72.28,1.15,0,.16-.01.3-.03.43ZM56.98,45.3c0-.29-.11-.52-.31-.69-.2-.17-.45-.26-.74-.26-.28,0-.51.08-.7.25s-.31.4-.35.7h2.1Z"
              id="e-5"
            />
            <path
              d="M62.69,43.93c.33.33.49.8.49,1.4v2.6h-1.12v-2.45c0-.35-.09-.62-.26-.81-.18-.19-.42-.28-.72-.28s-.55.09-.73.28-.27.46-.27.81v2.45h-1.12v-4.43h1.12v.55c.15-.19.34-.34.57-.45s.49-.16.76-.16c.53,0,.95.17,1.28.5Z"
              id="n-2"
            />
            <path
              d="M68.33,46.05h-3.24c.03.32.14.57.34.75.2.18.44.27.73.27.42,0,.71-.18.89-.54h1.21c-.13.43-.37.78-.74,1.05s-.81.41-1.34.41c-.43,0-.81-.09-1.15-.28-.34-.19-.6-.46-.79-.8s-.28-.75-.28-1.2.09-.86.28-1.21.45-.61.78-.8.72-.28,1.16-.28.8.09,1.13.27c.33.18.59.44.78.77.18.33.28.72.28,1.15,0,.16-.01.3-.03.43ZM67.2,45.3c0-.29-.11-.52-.31-.69-.2-.17-.45-.26-.74-.26-.28,0-.51.08-.7.25s-.3.4-.35.7h2.1Z"
              id="e-6"
            />
            <path
              d="M75.32,43.5l-1.3,4.43h-1.21l-.81-3.1-.81,3.1h-1.22l-1.3-4.43h1.14l.78,3.38.85-3.38h1.18l.83,3.37.78-3.37h1.07Z"
              id="w"
            />
            <path
              d="M75.93,47.8c-.13-.12-.2-.28-.2-.47s.07-.34.2-.47c.13-.13.3-.19.5-.19s.36.06.49.19c.13.12.19.28.19.47s-.06.34-.19.47-.29.19-.49.19-.37-.06-.5-.19Z"
              data-name="_x2E_"
              id="_x2E_-2"
            />
          </g>
          <g id="return.">
            <path
              d="M86.35,47.93l-1.23-2.18h-.53v2.18h-1.12v-5.58h2.1c.43,0,.8.08,1.1.23.3.15.53.36.68.62.15.26.23.55.23.87,0,.37-.11.7-.32,1-.21.3-.53.5-.95.61l1.34,2.26h-1.3ZM84.59,44.91h.94c.3,0,.53-.07.68-.22s.22-.35.22-.61-.08-.45-.22-.6-.38-.21-.68-.21h-.94v1.64Z"
              id="r-5"
            />
            <path
              d="M92.68,46.05h-3.24c.03.32.14.57.34.75.2.18.44.27.73.27.42,0,.71-.18.89-.54h1.21c-.13.43-.37.78-.74,1.05-.36.27-.81.41-1.34.41-.43,0-.81-.09-1.15-.28-.34-.19-.6-.46-.79-.8s-.28-.75-.28-1.2.09-.86.28-1.21.45-.61.78-.8c.34-.19.72-.28,1.16-.28s.8.09,1.13.27c.33.18.59.44.78.77.18.33.28.72.28,1.15,0,.16-.01.3-.03.43ZM91.55,45.3c0-.29-.11-.52-.31-.69-.2-.17-.45-.26-.74-.26-.28,0-.51.08-.7.25s-.3.4-.35.7h2.1Z"
              id="e-7"
            />
            <path
              d="M94.83,44.42v2.14c0,.15.04.26.11.32.07.07.19.1.36.1h.52v.94h-.7c-.94,0-1.42-.46-1.42-1.38v-2.14h-.53v-.92h.53v-1.1h1.13v1.1h.99v.92h-.99Z"
              id="t"
            />
            <path
              d="M100.82,43.5v4.43h-1.13v-.56c-.14.19-.33.34-.56.45-.23.11-.48.16-.76.16-.35,0-.65-.07-.92-.22s-.48-.36-.63-.65-.23-.62-.23-1.02v-2.6h1.12v2.44c0,.35.09.62.26.81.18.19.42.28.72.28s.55-.09.73-.28c.18-.19.26-.46.26-.81v-2.44h1.13Z"
              id="u"
            />
            <path
              d="M103.61,43.63c.23-.13.5-.2.8-.2v1.18h-.3c-.35,0-.62.08-.8.25s-.27.45-.27.86v2.21h-1.12v-4.43h1.12v.69c.14-.23.33-.42.56-.55Z"
              id="r-6"
            />
            <path
              d="M108.89,43.93c.33.33.49.8.49,1.4v2.6h-1.12v-2.45c0-.35-.09-.62-.26-.81-.18-.19-.42-.28-.72-.28s-.55.09-.73.28c-.18.19-.27.46-.27.81v2.45h-1.12v-4.43h1.12v.55c.15-.19.34-.34.57-.45.23-.11.49-.16.76-.16.53,0,.95.17,1.28.5Z"
              id="n-3"
            />
            <path
              d="M110.44,47.8c-.13-.13-.2-.28-.2-.47s.07-.34.2-.47c.13-.12.3-.19.5-.19s.36.06.49.19c.13.13.19.28.19.47s-.06.34-.19.47c-.13.12-.29.19-.49.19s-.37-.06-.5-.19Z"
              id="_x2E_-3"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
